import * as React from 'react';
import { AnalyticsEvent, logEvent } from '@weddingspot/ws-analytics';
import { SubHeader as  BaseSubHeader, SubHeaderTypes } from '@weddingspot/ws-core-components';


export interface Props {
    headerType: SubHeaderTypes;
}

const SubHeader = (props: Props) => {
    const logBreacrumbsEvent = () => {
        logEvent(AnalyticsEvent.EVTNM_CLICKED_BREADCRUMB, {
            Source: 'Profile',
        });
    };

    const logMySavedEstimatesEvent = () => {
        logEvent(AnalyticsEvent.EVTNM_CLICKED_MY_SAVED_ESTIMATES, {
            Location: 'SRP',
            'SRP Version': 2,
        });
    };

    return (
        <BaseSubHeader
            headerType={props.headerType}
            spotEstimatesURL='/myaccount/spot-estimates/'
            onBreacrumbsClick={logBreacrumbsEvent}
            onMySavedEstimatesClick={logMySavedEstimatesEvent}
        />);
};

export default SubHeader;